import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface CustomDialogProps {
  title: string;
  description: string;
  actionButtonText: string;
  onAction: () => void; // Function to call when action button is clicked
  onCancel: () => void; // Function to call when cancel button is clicked
  open: boolean; // Whether the dialog is open or not
}

const CustomDialog: React.FC<CustomDialogProps> = ({ title, description, actionButtonText, onAction, onCancel, open }) => {
  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="custom-dialog-title" aria-describedby="custom-dialog-description">
      <DialogTitle id="custom-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="custom-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onAction} color="error" autoFocus>
          {actionButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
